import React, { useState, useEffect } from "react";
import { DataTable } from "../../../components/tables";
import { alertListDataGridCols } from "./alertListDataGridCols";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";

const AlertList = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [alertData, setAlertData] = useState<any[]>([]);
  const [allAlertData, setAllAlertData] = useState<any[]>([]); 

  useEffect(() => {
    getAlertData();
  }, []);

  const getAlertData = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.allAlert(data).then((res: any) => {
      if (res.status === "Success") {
        setAlertData(res.data);
        setAllAlertData(res.data); 
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleSearch = () => {
    if (name.trim() === "") {
      setAlertData(allAlertData);
    } else {
      const filtered = allAlertData.filter((item: any) =>
        item.batchName?.toLowerCase().includes(name.toLowerCase())
      );
      setAlertData(filtered);
    }
  };

  const handleCancel = () => {
    setName("");
    setAlertData(allAlertData); 
  };

  const handleSignUpList = () => {
    navigate("/support/createalert");
  };

  const deleteAlertInfo = (batchId: string) => {
    const payload = { batchId };
    AdminService.deleteAlert(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getAlertData();
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleEditAlert = (data: any) => {
    navigate("/support/createedit", { state: data });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            <div className="row">
              <div className="col-md-6 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <b>Alert List</b>
                </label>
                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e: any) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the BatchName"
                  />
                  <button
                    className="btn btn-primary rounded px-4 py-1"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="col-md-6 mt-3">
                <div className="text-end">
                  <button className="btn btn-success" onClick={handleSignUpList}>
                    Create Alert
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <DataTable
                tableData={alertData}
                TableCols={alertListDataGridCols}
                deleteSignUpListInfo={deleteAlertInfo}
                handleEditUser={handleEditAlert}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertList;
